var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpander(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/noticon/expander") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/noticon/expander",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.600631,35.0939178 L58.9799413,35.0939178 C60.8081943,35.0939178 62.2902862,36.4370635 62.2902862,38.0939178 C62.2902862,39.6915986 60.9121676,40.9975786 59.1744493,41.0888251 L58.9799413,41.0939178 L1.600631,41.0939178 C-0.227621961,41.0939178 -1.70971382,39.750772 -1.70971382,38.0939178 C-1.70971382,36.4962369 -0.331595242,35.1902569 1.4061231,35.0990105 L1.600631,35.0939178 L58.9799413,35.0939178 L1.600631,35.0939178 Z M17.0649465,19.8625856 L44.5199706,19.8625856 C46.0511734,19.8625856 47.2924585,21.2057314 47.2924585,22.8625856 C47.2924585,24.4602665 46.1382533,25.7662465 44.6828753,25.8574929 L44.5199706,25.8625856 L17.0649465,25.8625856 C15.5337437,25.8625856 14.2924585,24.5194399 14.2924585,22.8625856 C14.2924585,21.2649048 15.4466637,19.9589248 16.9020417,19.8676783 L17.0649465,19.8625856 L44.5199706,19.8625856 L17.0649465,19.8625856 Z",
    id: "Radio-Signal",
    fill: "#6E6E77",
    transform: "translate(30.290286, 30.478252) rotate(-224.000000) translate(-30.290286, -30.478252) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpander);
export default __webpack_public_path__ + "static/media/expander.55ce8abd9d7d878cec03f3c0fb0d2443.svg";
export { ForwardRef as ReactComponent };